import { TextField, Stack, Button, Popper, Autocomplete } from "@mui/material";
import React, { useState } from "react";
// import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import { Form, Formik, Field } from "formik";
import moment from "moment";
import { useAxios } from "../../hooks/useAxios.js";

const DashboardFilter = ({
  filterClose,
  filterObject,
  hospital,
  fieldworkerList,
  filterPerform,
}) => {
  const [campStartDate, setStartDate] = useState(null);
  const [campEndDate, setEndDate] = useState(null);
  // const [campStartDate, setStartDate] = useState(moment().startOf("month"));
  // const [campEndDate, setEndDate] = useState(new Date());
  const [fieldValue, setFieldValue] = useState("");
  const [fieldWorker, setFieldWorkerValue] = useState("");

  const { axios } = useAxios();
  const [reset, setReset] = useState(false);

  const [fieldreset, setFieldreset] = useState({
    vhv: 1,
    cbbf: 2,
  });

  // const state = {
  //   field_worker_id: "",
  // }
  //   const [field, setInitialValue] = useState(state);

  const fW = {
    vhv: null,
    cbbf: null,
  };

  // const [fieldWorkers, setFieldWorkers] = useState(fW);
  const [fieldWorkers, setFieldWorkers] = useState(Array.isArray(fW) ? fW : []);

  const handleSubmit = () => {
    let obj = {
      fromDate: campStartDate
        ? moment(campStartDate.$d).format("YYYY-MM-DD")
        : "",
      toDate: campEndDate ? moment(campEndDate.$d).format("YYYY-MM-DD") : "",
      hospital_id: fieldValue ? fieldValue : "",
      field_worker_id: fieldWorker ? fieldWorker : "",
    };
    let perform = {
      fromDate: campStartDate
        ? moment(campStartDate.$d).format("YYYY-MM-DD")
        : "",
      toDate: campEndDate ? moment(campEndDate.$d).format("YYYY-MM-DD") : "",
      hospital_id: fieldValue ? fieldValue : "",
      field_worker_id: fieldWorker ? fieldWorker : "",
    };
    filterObject(obj);
    filterPerform(perform);
  };

  const handleClose = () => {
    let obj = {
      fromDate: "",
      toDate: "",
      hospital_id: "",
      field_worker_id: "",
    };
    let perform = {
      hospital_id: "",
      field_worker_id: "",
    };
    filterObject(obj);
    filterPerform(perform);
    setFieldWorkerValue("");
    setFieldValue("");
    setStartDate(null);
    setEndDate(null);
    // filterClose(false)
    handleFieldWorkerDropdown();
  };

  async function handleChangeHospital(e) {
    if (e.target.value != undefined) {
      // to handle no data found
      const data = hospital.find((data) => data._id === e.target.value);
      console.log(data);

      setFieldreset({
        ...fieldreset,
        vhv: fieldreset.vhv + 0.1,
        cbbf: fieldreset?.cbbf + 0.1,
      });

      // setFieldValue(data);

      const p_load = {
        hospital_id: [data._id],
      };

      // p_load = {
      //   hospital_id: [value],
      // };

      console.log("p_load", p_load);

      handleFieldWorkerDropdown(p_load);
    }
  }

  async function handleFieldWorkerDropdown(data) {
    try {
      const res = await axios.post("getGISFieldWorkerList", data ?? {});
      const field_w = res.data?.result?.result || [];
      let vhvFieldWorkers =
        field_w.length > 0
          ? field_w?.filter((param) => param?.field_worker_typeId === 3)
          : [];

      const workerList = Array.isArray(vhvFieldWorkers[0]?.filed_workerList)
        ? vhvFieldWorkers[0].filed_workerList
        : [];

      setFieldWorkers(workerList);
      setFieldWorkerValue("");
    } catch (err) {
      console.error(err);
      setFieldWorkers([]);
    }
    // await axios.post("getGISFieldWorkerList", data).then((res) => {
    //   var field_w = res.data?.result?.result || [];

    //   // var vhvvalue = field_w?.find((i) => i.field_worker_type === "VHV");
    //   // var cbbfvalue = field_w?.find((i) => i.field_worker_type === "CBBF");

    //   // vhvvalue = vhvvalue == undefined ? {} : vhvvalue;
    //   // cbbfvalue = cbbfvalue == undefined ? {} : cbbfvalue;

    //   if(field_w.length > 0){
    //     console.log("asdf:", JSON.stringify(field_w));
    //   const workerList = field_w[0]?.filed_workerList || [];
    //   console.log("workerList:", workerList);

    //   setFieldWorkers(workerList);
    //  }

    //   setFieldWorkerValue("");
    // });
  }

  console.log("fieldWorkerasdf:", fieldWorkers);

  return (
    <div style={{ width: "65vw", margin: "10px 0" }}>
      <Stack direction="row" spacing={2} sx={{ alignItems: "end" }}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="From Date"
            renderInput={(props) => <TextField {...props} size="small" />}
            value={campStartDate}
            onChange={(newValue) => {
              setStartDate(newValue);
            }}
          />
        </LocalizationProvider>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="To Date"
            renderInput={(props) => <TextField {...props} size="small" />}
            value={campEndDate}
            onChange={(newValue) => {
              setEndDate(newValue);
            }}
          />
        </LocalizationProvider>

        <FormControl style={{ width: "30%" }}>
          <InputLabel
            id="select-label"
            // style={{ marginLeft: "-3%", marginTop: "1%" }}
          >
            Select Hospital
          </InputLabel>
          <Select
            labelId="select-label"
            id="select"
            variant="standard"
            value={fieldValue}
            placeholder="Select Hospital"
            onChange={(event) => {
              setFieldValue(event.target.value);
              handleChangeHospital(event);
            }}
          >
            {hospital.map((option) => (
              <MenuItem key={option._id} value={option._id}>
                {option.hospital_name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* <FormControl style={{ width: "30%" }}>
          <InputLabel
            id="select-label"
            // style={{ marginLeft: "-3%", marginTop: "1%" }}
          >
            Fieldworker Name
          </InputLabel>
          <Select
            labelId="select-label"
            id="select"
            variant="standard"
            value={fieldWorker}
            placeholder="Select Hospital"
            onChange={(event) => {
              setFieldWorkerValue(event.target.value);
            }}
          >
           {(fieldWorkers || []).sort((a, b) => a.field_worker_name.localeCompare(b.field_worker_name)).map((option) => (
              <MenuItem
                key={option.field_worker_id}
                value={option.field_worker_id}
              >
                {option.field_worker_name}
              </MenuItem>
            ))}
          </Select>
        </FormControl> */}

        <FormControl style={{ width: "30%" }}>
          <Autocomplete
            options={(fieldWorkers || [])
              .filter((fw) => fw && fw.field_worker_name)
              .sort((a, b) =>
                a.field_worker_name.localeCompare(b.field_worker_name)
              )}
            getOptionLabel={(option) => option?.field_worker_name || ""}
            isOptionEqualToValue={(option, value) =>
              option.field_worker_id === value.field_worker_id
            }
            renderOption={(props, option) => (
              <li {...props} key={option.field_worker_id}>
                {option.field_worker_name}
              </li>
            )}
            value={
              fieldWorkers?.length
                ? fieldWorkers.find(
                    (fw) => fw.field_worker_id === fieldWorker
                  ) || null
                : null
            }
            onChange={(event, newValue) => {
              setFieldWorkerValue(newValue ? newValue.field_worker_id : null);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Fieldworker Name"
                variant="standard"
                placeholder="Select Fieldworker"
              />
            )}
          />
        </FormControl>

        <Button
          variant="contained"
          style={{ width: "11%" }}
          onClick={handleSubmit}
        >
          Search
        </Button>
        <Button
          sx={{ textTransform: "capitalize" }}
          variant="contained"
          style={{ width: "11%" }}
          onClick={handleClose}
        >
          Reset
        </Button>
      </Stack>
    </div>
  );
};
export default DashboardFilter;
